/**
 * Derive org-level permissions for the current user.
 *
 * @param {Object[]} memberships - userOrgMembership records
 * @param {string} activeOrgId   - currently selected org id
 * @param {boolean} issuperadmin - global superadmin flag
 */

 function getId(val) {
   if (!val) return null;

   // ObjectId or primitive
   if (typeof val === 'string' || typeof val === 'number') {
     return String(val);
   }

   // Mongoose ObjectId
   if (val._id) {
     return String(val._id);
   }

   // Fallback (covers raw ObjectId instances)
   return String(val);
 }


export function getOrgPermissions({
  memberships = [],
  activeOrgId,
  issuperadmin = false
}) {
  const activeMembership = memberships.find(
    m => m.orgId === activeOrgId
  );
  const roles = activeMembership?.roles || [];

  console.log({
    activeOrgId,
    activeOrgIdType: typeof activeOrgId,
    memberships: memberships.map(m => ({
      rawOrgId: m.orgId,
      rawType: typeof m.orgId,
      normalized: getId(m.orgId)
    }))
  });


  const isOwner = roles.includes('org:owner');
  const isAdmin = roles.includes('org:admin');
  const isUser  = roles.includes('org:user');

  // can manage users inside the org
  const canAddUser = issuperadmin || isOwner || isAdmin;

  // can create new orgs (global action)
  const canAddOrg =
    issuperadmin ||
    memberships.some(m => m.roles?.includes('org:owner'));

  return {
    activeMembership,
    roles,

    isOwner,
    isAdmin,
    isUser,

    canAddUser,
    canAddOrg,

    // useful future flags
    isOrgAdmin: isOwner || isAdmin,
    hasOrgAccess: !!activeMembership || issuperadmin
  };
}
